PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'

module.exports = class RenameBoardView extends View
  viewTitleKey: 'rename board'

  events:
    'click .js-rename-board': 'rename'
    'submit form': 'rename'

  render: (e) ->
    data = {}
    data.boardName = @model.get('name')

    @$el.html(
      templates.fill(
        'popover_rename_board',
        data
      )
    )
    @

  rename: (e) ->
    Util.stop(e)
    $boardName = @$('.js-board-name')
    val = $boardName.val().trim()
    if val == ''
      $boardName.focus().select()
      return
    track("Board", "Successfully Rename Board")
    @model.update("name", val)
    PopOver.hide()
    return
